// 电池详情
export default {
    owner: 'владелец',
    phone: 'телефонный номер',
    aircraftNumber: 'Номер самолета',
    chargerNumber: 'Номер зарядного устройства',
    reportingTime: 'время отчетности',
    TUT: 'Общее использованное время',
    TOC: 'Циклы',
    ODT: 'Время перегрузки',
    BLS: 'Статистика автономной работы',
    residualLife: 'Оставшаяся жизнь',
}